<template>
  <div class="methodedetail">
    <div class="methodedetail-header">
      <h1>{{ methode.name }}</h1>
    </div>

    <div class="qualities-tips">
      <div class="qualities-tips__left">
        <div class="qualities">
          <h4>Democratische waarden</h4>
          <ul class="qualities__list">
            <li
              v-for="(waarde, index) in methode.values"
              :key="waarde.waardeindex"
              class="quality-row"
              v-bind:class="{ active: active == waarde }"
            >
              <div class="quality">
                <span
                  class="quality-icon"
                  :class="'icon-' + cleanClass(waarde.waarde)"
                ></span>
                <span
                  @click="getTipsWaarde(waarde, waarde.waardeindex)"
                  class="quality-text link"
                  >{{ waarde.waarde }}</span
                >

                <span class="quality-scores">
                  <span
                    class="star"
                    v-for="n in parseInt(waarde.score)"
                    :key="n"
                  ></span>
                  <span
                    class="star star--empty"
                    v-for="n in parseInt(5 - waarde.score)"
                    :key="n + 10"
                  ></span>
                </span>
              </div>
              <div class="quality-explained" v-html="waarde.kort"></div>
            </li>
          </ul>
        </div>
      </div>

      <div class="qualities-tips__right" v-if="tipdata.tips">
        <TipCard :tipdata="tipdata" :hiddenTips="hiddenTips"></TipCard>
      </div>
    </div>
  </div>
</template>

<script>
import TipCard from "../components/TipCard.vue";

const ENDPOINT_NAME = "ppw/v1/methode";
const axios = require("axios");

export default {
  emits: ["updateMethodid"],

  name: "methodeDetail",

  data() {
    return {
      tips: "",
      active: "",
      storeMethods: [],
      storeIndex: 0,
      hiddenTips: [],
      slug: "",
    };
  },

  props: {
    method: Number,
    waarde: Number,
    methode: Object,
    tipsArray: Array,
  },

  components: {
    TipCard,
  },

  computed: {
    tipdata() {
      return this.tipsArray;
    },
  },

  methods: {
    // todo: haal methode object op en geef het door aan getTips
    getTipsWaarde: function (waarde, index) {
      this.active = waarde;
      this.tipsArray = this.getTips(this.methode, index);
    },

    cleanClass(j) {
      return j.replace(/ \/ /g, "");
    },

    setMethodeDetail(id, waarde) {
      const url = new URL(
        process.env.VUE_APP_REST_URL + ENDPOINT_NAME + "?method=" + id
      );
      this.isLoading = true;
      this.isEmptyResult = false;

      // fetch(url)
      axios
        .get(url)
        .then((r) => {
          const results = r.data;
          if (!results) {
            this.methode = {};
            this.isEmptyResult = true;
          } else {
            this.methodeID = id;
            this.waardeindex = waarde;
            this.methode = r.data.methode;
            if (this.methode.values.length > 0) {
              this.active = this.methode.values[0];
            }
          }
        })
        .catch((error) => {
          console.warn(error);
        });
    },

    getTips: function (method, waardeidx) {
      let holdTips = [];

      // dit toont de tips bij een democratische waarde
      if (method.values[waardeidx].tips) {
        holdTips["method"] = method.name_short;
        holdTips["waarde"] = method.values[waardeidx].waarde;
        holdTips["beschrijving"] = method.values[waardeidx].tekst;
        holdTips["tips"] = [];

        let tipsArray = method.values[waardeidx].tips;
        let tipsLength = method.values[waardeidx].tips.length;

        if (localStorage.getItem("hiddenTips"))
          this.hiddenTips = JSON.parse(localStorage.getItem("hiddenTips"));
        else this.hiddenTips = [];

        for (var i = 0; i < tipsLength; i++) {
          let thistip = [];
          let tipIsChecked = true;
          thistip["checkboxvalue"] = "tipcheck_" + tipsArray[i].id;
          thistip["id"] = tipsArray[i].id;
          thistip["value"] = tipsArray[i].value;
          thistip["checked"] = tipIsChecked;
          holdTips["tips"][i] = thistip;
        }
        return holdTips;
      }
    },
  },

  created() {},

  mounted() {
    if (!localStorage.getItem("hiddenTips")) {
      const parsed = JSON.stringify(this.hiddenTips);
      localStorage.setItem("hiddenTips", parsed);
    }
    this.hiddenTips = JSON.parse(localStorage.getItem("hiddenTips"));
  },
};
</script>

